import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import auth from './store/auth';

import Home from './containers/Home';
import Login from './containers/Login';
import Logout from './containers/Logout';

import User from './containers/User'
import UserCreate from './containers/UserCreate'
import UserUpdate from './containers/UserUpdate'

import Org from './containers/Org'
import OrgCreate from './containers/OrgCreate'
import OrgUpdate from './containers/OrgUpdate'

import UploadData from './containers/UploadData'
import DownloadData from './containers/DownloadData'
import DocDetail from './containers/DocDetail'

import SharedDoc from './containers/SharedDoc'
import ShDocDetail from './containers/ShDocDetail'

import ReviewDoc from './containers/ReviewDoc'
import RvwDocDetail from './containers/RvwDocDetail'
import RvwdList from './containers/RvwdList'

import ApproveDoc from './containers/ApproveDoc'
import ApprDocDetail from './containers/ApprDocDetail'
import ApprvdList from './containers/ApprvdList'

import SendEmail from './containers/SendEmail'
import BCExpl from './containers/BCExpl'

import DocHist from './containers/DocHist'
import DocHistDetail from './containers/DocHistDetail'

import Reports from './containers/Reports'
import RvwPenRep from './containers/RvwPenRep'
import RvwdRep from './containers/RvwdRep'
import AppPenRep from './containers/AppPenRep'
import AppdRep from './containers/AppdRep'
import DocGrpRep from './containers/DocGrpRep'

import DocGrp from './containers/DocGrp'
import DocGrpDtl from './containers/DocGrpDtl'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    auth.isUserAuthenticated()
      ? <Component {...props} />
      : <Redirect to='/login' />
  )} />
);

// The Main component renders one of the three provided
// Routes (provided that one matches). The / route will only match
// when the pathname is exactly the string "/"
const Main = () => {
  console.log('inside main');

  return (<main className={`${auth.isUserAuthenticated() ? 'width-80per' : 'width-100per login'}`}>
    <Switch>
      <Route exact path='/login' component={Login} />
      <Route exact path='/logout' component={Logout} />
      <PrivateRoute exact path='/' component={Home}/>

      <PrivateRoute path='/org/:id' component={OrgUpdate}/>
      <PrivateRoute path='/org' component={Org}/>
      <PrivateRoute path='/orgcreate' component={OrgCreate}/>
      <PrivateRoute path='/org/OrgUpdate' component={OrgUpdate}/>

      <PrivateRoute path='/user/:id' component={UserUpdate}/>
      <PrivateRoute path='/user' component={User}/>
      <PrivateRoute path='/usercreate' component={UserCreate}/>
      <PrivateRoute path='/user/UserUpdate' component={UserUpdate}/>

      <PrivateRoute path='/uploaddata' component={UploadData}/>

      <PrivateRoute path='/downloaddata' component={DownloadData}/>
      <PrivateRoute path='/docdetail/:id' component={DocDetail}/>

      <PrivateRoute path='/shareddoc' component={SharedDoc}/>
      <PrivateRoute path='/shdocdetail/:id' component={ShDocDetail}/>

      <PrivateRoute path='/reviewdoc' component={ReviewDoc}/>
      <PrivateRoute path='/rvwdocdetail/:id' component={RvwDocDetail}/>
      <PrivateRoute path='/rvwdlist' component={RvwdList}/>

      <PrivateRoute path='/approvedoc' component={ApproveDoc}/>
      <PrivateRoute path='/apprdocdetail/:id' component={ApprDocDetail}/>

      <PrivateRoute path='/apprvdlist' component={ApprvdList}/>

      <PrivateRoute path='/sendemail' component={SendEmail}/>

      <PrivateRoute path='/bcexpl' component={BCExpl}/>

      <PrivateRoute path='/reports' component={Reports}/>
      <PrivateRoute path='/rvwpenrep' component={RvwPenRep}/>
      <PrivateRoute path='/rvwdrep' component={RvwdRep}/>
      <PrivateRoute path='/apppenrep' component={AppPenRep}/>
      <PrivateRoute path='/appdrep' component={AppdRep}/>
      <PrivateRoute path='/docgrprep' component={DocGrpRep}/>


      <PrivateRoute path='/dochist' component={DocHist}/>
      <PrivateRoute path='/dochistdetail/:id' component={DocHistDetail}/>

      <PrivateRoute path='/docgrp' component={DocGrp}/>
      <PrivateRoute path='/docgrpdtl/:id' component={DocGrpDtl}/>

    </Switch>
  </main>)
};

export default Main



// WEBPACK FOOTER //
// ./src/main.js